import React from 'react'
import { FormControl, TextField } from '@material-ui/core'
import PropTypes from 'prop-types'

const FormField = props => {
  const { name, errors, autoFocus } = props

  if (!errors.hasOwnProperty(name)) {
    props = { ...props, error: false, helperText: '' }
  } else {
    props = { ...props, error: true, helperText: errors[name].message }
  }

  return (
    <FormControl
      margin={name !== 'username' ? 'normal' : ''}
      style={name !== 'username' ? { display: 'flex' } : { display: 'none' }}
      fullWidth
      data-cid={`Formfield-root`}
    >
      <TextField
        data-qid={`Formfield-${props.id}`}
        variant='outlined'
        autoFocus={autoFocus}
        {...props}
      />
    </FormControl>
  )
}

FormField.propTypes = {
  /** Id is required for QA Automation. */
  id: PropTypes.any.isRequired,
  /** Placeholder for the component. **/
  label: PropTypes.any.isRequired,
  /** Name for form validation reference. **/
  name: PropTypes.any.isRequired,
  /** UX feature for browser to show relevant data on the field for easier completion of forms. **/
  autoComplete: PropTypes.any,
  /** Callback fired when the value is changed. **/
  onChange: PropTypes.func,
  /** The value of the Input element, required for a controlled component. **/
  value: PropTypes.string,
  /** Type attribute of the Input element. It should be a valid HTML5 input type. **/
  type: PropTypes.any,
  /** Error object that contains error message and type from form validation. **/
  errors: PropTypes.any,
  /** Reference function for form validation. For specification follow https://react-hook-form.com/get-started#Registerfields**/
  inputRef: PropTypes.any,
  /** Set the field to has autofocus */
  autoFocus: PropTypes.bool,
}

export default FormField
